import { DISPATCH_METHODS } from '~constants/address';
import { DEFAULT_STORE_ID } from '~constants/environment';

export const isActualStoreClosed = storeInfo => {
  const { currentSubsidiary, dispatchType } = storeInfo;
  const storeIsOpen =
    dispatchType === DISPATCH_METHODS.IN_STORE && !currentSubsidiary?.papacar
      ? currentSubsidiary?.pickUpOpen
      : currentSubsidiary?.deliveryOpen;
  return storeIsOpen === undefined ? !currentSubsidiary?.open : !storeIsOpen;
};

export const isOpenActualStore = storeInfo => {
  const { currentSubsidiary, dispatchType } = storeInfo;

  return dispatchType === DISPATCH_METHODS.IN_STORE && !currentSubsidiary?.papacar
    ? currentSubsidiary.pickUpOpen
    : currentSubsidiary.deliveryOpen;
};

export const isStoreClosedWithLaterOrder = (storeInfo, futureOrdersEnabled) =>
  !!(isActualStoreClosed(storeInfo) && futureOrdersEnabled);

export const isFakeStore = store => DEFAULT_STORE_ID === store.id;
